import { type FC } from "react";
import { Link } from "@root/shared/components/Link";
import { Button } from "@root/shared/components/Button";
import { useFormContext } from "react-hook-form";
import { HeadingAndRadioButtons } from "./uiParts/HeadingAndRadioButtons";
import { HeadingAndCheckboxAndTextArea } from "./uiParts/HeadingAndCheckboxAndTextArea";
import * as styles from "./styles.css";
import { type PresentationProps } from "./type";

export const Presentation: FC<PresentationProps> = ({
  backHref,
  questions: {
    question1,
    question2,
    question3,
    question4,
    question5,
    question5Sub,
    question6,
    question6Sub,
    question7,
    question7Sub,
    question8,
    question8Sub,
    question9,
    question10,
    question11,
  },
  selectedQuestionSubFlags,
  selectedQuestionOtherFlags,
}) => {
  const { formState } = useFormContext();
  return (
    <>
      <div className={styles.questionsOuter}>
        <section className={styles.questionOuter}>
          <HeadingAndRadioButtons
            {...question1}
            questionTitle={`1. ${question1.questionTitle}`}
            titleTag="h2"
          />
        </section>
        <section className={styles.questionOuter}>
          <HeadingAndCheckboxAndTextArea
            questionTitle={`2. ${question2.questionTitle}`}
            titleTag="h2"
            textAreaProps={{
              placeholder: question2.placeholder,
              name: question2.name,
            }}
          />
        </section>
        <section className={styles.questionOuter}>
          <HeadingAndRadioButtons
            {...question3}
            questionTitle={`3. ${question3.questionTitle}`}
            titleTag="h2"
          />
        </section>
        <section className={styles.questionOuter}>
          <HeadingAndCheckboxAndTextArea
            questionTitle={`4. ${question4.questionTitle}`}
            titleTag="h2"
            checkboxesProps={question4.checkboxesProps}
            textAreaProps={question4.textAreaProps}
            isOtherChecked={selectedQuestionOtherFlags.question4}
          />
        </section>
        <section className={styles.questionOuter}>
          <HeadingAndRadioButtons
            {...question5}
            questionTitle={`5. ${question5.questionTitle}`}
            titleTag="h2"
          />
        </section>
        {selectedQuestionSubFlags.question5 && (
          <section className={styles.questionOuter}>
            <HeadingAndCheckboxAndTextArea
              questionTitle={`5-2. ${question5Sub.questionTitle}`}
              titleTag="h2"
              checkboxesProps={question5Sub.checkboxesProps}
              textAreaProps={question5Sub.textAreaProps}
              isOtherChecked={selectedQuestionOtherFlags.question5Sub}
            />
          </section>
        )}
        <section className={styles.questionOuter}>
          <HeadingAndRadioButtons
            {...question6}
            questionTitle={`6. ${question6.questionTitle}`}
            titleTag="h2"
          />
        </section>
        {selectedQuestionSubFlags.question6 && (
          <section className={styles.questionOuter}>
            <HeadingAndCheckboxAndTextArea
              questionTitle={`6-2. ${question6Sub.questionTitle}`}
              titleTag="h2"
              checkboxesProps={question6Sub.checkboxesProps}
              textAreaProps={question6Sub.textAreaProps}
              isOtherChecked={selectedQuestionOtherFlags.question6Sub}
            />
          </section>
        )}
        <section className={styles.questionOuter}>
          <HeadingAndRadioButtons
            {...question7}
            questionTitle={`7. ${question7.questionTitle}`}
            titleTag="h2"
          />
        </section>
        {selectedQuestionSubFlags.question7 && (
          <section className={styles.questionOuter}>
            <HeadingAndCheckboxAndTextArea
              questionTitle={`7-2. ${question7Sub.questionTitle}`}
              titleTag="h2"
              checkboxesProps={question7Sub.checkboxesProps}
              textAreaProps={question7Sub.textAreaProps}
              isOtherChecked={selectedQuestionOtherFlags.question7Sub}
            />
          </section>
        )}
        <section className={styles.questionOuter}>
          <HeadingAndRadioButtons
            {...question8}
            questionTitle={`8. ${question8.questionTitle}`}
            titleTag="h2"
          />
        </section>
        {selectedQuestionSubFlags.question8 && (
          <section className={styles.questionOuter}>
            <HeadingAndCheckboxAndTextArea
              questionTitle={`8-2. ${question8Sub.questionTitle}`}
              titleTag="h2"
              checkboxesProps={question8Sub.checkboxesProps}
              textAreaProps={question8Sub.textAreaProps}
              isOtherChecked={selectedQuestionOtherFlags.question8Sub}
            />
          </section>
        )}
        <section className={styles.questionOuter}>
          <HeadingAndCheckboxAndTextArea
            questionTitle={`9. ${question9.questionTitle}`}
            titleTag="h2"
            checkboxesProps={question9.checkboxesProps}
            textAreaProps={question9.textAreaProps}
            isOtherChecked={selectedQuestionOtherFlags.question9}
          />
        </section>
        <section className={styles.questionOuter}>
          <HeadingAndRadioButtons
            {...question10}
            questionTitle={`10. ${question10.questionTitle}`}
            titleTag="h2"
          />
        </section>
        <section className={styles.questionOuter}>
          <HeadingAndCheckboxAndTextArea
            questionTitle={`11. ${question11.questionTitle}`}
            titleTag="h2"
            textAreaProps={{
              placeholder: question11.placeholder,
              name: question11.name,
            }}
          />
        </section>
      </div>
      <div className={styles.buttonsOuter}>
        <Link theme="tertiary" href={backHref}>
          戻る
        </Link>
        <Button type="submit" theme={formState.isSubmitting ? "disabled" : "primary"}>
          次へ
        </Button>
      </div>
    </>
  );
};
